export const USER_MANAGEMENT_FETCH_REQUEST = 'USER_MANAGEMENT_FETCH_REQUEST';
export const USER_MANAGEMENT_FETCH_SUCCESS = 'USER_MANAGEMENT_FETCH_SUCCESS';
export const USER_MANAGEMENT_FETCH_FAILURE = 'USER_MANAGEMENT_FETCH_FAILURE';

export const USER_MANAGEMENT_ADMINS_FETCH_REQUEST = 'USER_MANAGEMENT_ADMINS_FETCH_REQUEST';
export const USER_MANAGEMENT_ADMINS_FETCH_SUCCESS = 'USER_MANAGEMENT_ADMINS_FETCH_SUCCESS';
export const USER_MANAGEMENT_ADMINS_FETCH_FAILURE = 'USER_MANAGEMENT_ADMINS_FETCH_FAILURE';

export const USER_MANAGEMENT_ADD_REQUEST = 'USER_MANAGEMENT_ADD_REQUEST';
export const USER_MANAGEMENT_ADD_SUCCESS = 'USER_MANAGEMENT_ADD_SUCCESS';
export const USER_MANAGEMENT_ADD_FAILURE = 'USER_MANAGEMENT_ADD_FAILURE';

export const USER_MANAGEMENT_UPDATE_REQUEST = 'USER_MANAGEMENT_UPDATE_REQUEST';
export const USER_MANAGEMENT_UPDATE_SUCCESS = 'USER_MANAGEMENT_UPDATE_SUCCESS';
export const USER_MANAGEMENT_UPDATE_FAILURE = 'USER_MANAGEMENT_UPDATE_FAILURE';

export const USER_MANAGEMENT_STATUS_UPDATE_REQUEST = 'USER_MANAGEMENT_STATUS_UPDATE_REQUEST';
export const USER_MANAGEMENT_STATUS_UPDATE_SUCCESS = 'USER_MANAGEMENT_STATUS_UPDATE_SUCCESS';
export const USER_MANAGEMENT_STATUS_UPDATE_FAILURE = 'USER_MANAGEMENT_STATUS_UPDATE_FAILURE';

export const USER_MANAGEMENT_VALIDATE_FIELD_REQUEST = 'USER_MANAGEMENT_VALIDATE_FIELD_REQUEST';
export const USER_MANAGEMENT_VALIDATE_FIELD_SUCCESS = 'USER_MANAGEMENT_VALIDATE_FIELD_SUCCESS';
export const USER_MANAGEMENT_VALIDATE_FIELD_FAILURE = 'USER_MANAGEMENT_VALIDATE_FIELD_FAILURE';

export const USER_MANAGEMENT_CLEAR_ERRORS = 'USER_MANAGEMENT_CLEAR_ERRORS';
export const USER_MANAGEMENT_RESET_SUCCESS = 'USER_MANAGEMENT_RESET_SUCCESS';
